/* eslint-disable jsx-a11y/img-redundant-alt, import/extensions */
/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";

import Headline from "../../atoms/headline";

import "./about-us.m.css";

const getVideoId = videoElementUrl => {
  var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  var match = videoElementUrl.match(regExp);

  if (match && match[2].length === 11) {
    return match[2];
  } else {
    return "error";
  }
};

class AboutUsMolecule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }

  componentDidMount() {
    this.setState({ width });
  }

  render() {
    const { story } = this.props;
    const storyObj = story.story ? story.story : story;

    const videoElementUrl = get(
      storyObj,
      ["cards", "0", "story-elements", "0", "url"],
      "https://www.youtube.com/watch?v=bxe5_Z2lfUE"
    );
    const src = `//www.youtube.com/embed/${getVideoId(videoElementUrl)}`;

    return (
      <div styleName="wrapper">
        {this.state.width < 768 && <Headline text={storyObj.headline} headerLevel={2} headerType={2} />}
        {this.state.width < 768 && (
          <div styleName="youtube-wrapper">
            <iframe src={src} width="335" height="189" frameBorder="0" allowFullScreen />
          </div>
        )}
        {this.state.width > 768 && (
          <div styleName="youtube-wrapper">
            <WithLazy margin="50px">
              {() => <iframe src={src} width="558" height="316" frameBorder="0" allowFullScreen />}
            </WithLazy>
          </div>
        )}
        <div styleName="summary">
          {this.state.width > 768 && <Headline text={storyObj.headline} headerLevel={2} headerType={2} />}
          <p styleName="description">{storyObj.summary || storyObj.subheadline}</p>
          <a className="default-link-button" href="/about-ncf">
            KNOW MORE
          </a>
        </div>
      </div>
    );
  }
}

export default AboutUsMolecule;

AboutUsMolecule.propTypes = {
  story: object
};
